module.exports = __webpack_public_path__ + "static/img/中雪.b4d07ce7.svg";